// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"f69cedb0","127":"cb5712f7","149":"cb6960d7","454":"f4567d48","520":"1814bb97","553":"2a681dee","653":"916f620b","750":"8904fe86","854":"d92f3893","858":"6b6ca322"}[chunkId] + ".chunk.js";
};